export type InvoiceStatusDisplay = 'paid' | 'unpaid' | 'overdue' | 'sent' | 'draft' | 'cancelled';

/**
 * Determines the display status of an invoice.
 * Uses the backend status field when available, falling back
 * to the paid boolean for backward compatibility.
 */
export function getInvoiceStatus(invoice: { status?: string; paid: boolean }): InvoiceStatusDisplay {
  if (invoice.status) {
    return invoice.status.toLowerCase() as InvoiceStatusDisplay;
  }
  return invoice.paid ? 'paid' : 'unpaid';
}

/**
 * Formats a numeric amount as a locale-aware currency string
 * using the Australian English locale by default.
 */
export function formatCurrency(amount: number, currency: string = 'AUD'): string {
  return new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
}
